<template>
  <div>
    <c-search-box ref="searchbox" @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <c-select
            codeGroupCd="VENDOR_CLASS_CD"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="vendorClassCd"
            label="업체분류"
            v-model="searchParam.vendorClassCd"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <c-select
            codeGroupCd="VENDOR_TYPE_CD"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="vendorTypeCd"
            label="업체유형"
            v-model="searchParam.vendorTypeCd"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="vendorTable"
      title="수급업체 목록"
      :columns="grid.columns"
      :data="grid.data"
      :gridHeight="grid.height"
      :selection="popupParam.type"
      :columnSetting="false"
      :isExcelDown="false"
      :isFullScreen="false"
      rowKey="vendorCd"
      @rowDblclick="rowDblclick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
          <c-btn label="LBLSELECT" icon="check" @btnClicked="select" />
        </q-btn-group>
      </template>
    </c-table>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'vendor-pop',
  props: {
    popupParam: {
      type: Object,
      default: function() {
        return {
          type: 'single',
          plantCd: '',
        }
      },
    },
    contentHeight: {
      type: [String, Number],
      default: function() {
        return 'auto'
      },
    }
  },
  data() {
    return {
      grid: {
        columns: [
          {
            name: 'vendorClassName',
            field: 'vendorClassName',
            label: '업체분류',
            align: 'center',
            style: 'width:150px',
            sortable: true,
          },
          {
            name: 'vendorTypeName',
            field: 'vendorTypeName',
            label: '업체유형',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'vendorName',
            field: 'vendorName',
            label: '업체',
            align: 'left',
            sortable: true,
          },
          {
            name: 'plantNames',
            field: 'plantNames',
            label: '관련사업장',
            align: 'center',
            style: 'width:250px',
            sortable: true,
          },
        ],
        data: [],
        height: '500px'
      },
      searchParam: {
        plantCd: null,
        vendorClassCd: null,
        vendorTypeCd: null,
      },
      editable: true,
      listUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  watch: {
  },
  methods: {
    init() {
      this.listUrl = selectConfig.mdm.cim.vendor.list.url;
      if (this.popupParam.plantCd) {
        this.searchParam.plantCd = this.popupParam.plantCd
      }
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    select() {
      let selectData = this.$refs['vendorTable'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: 'LBLGUIDE', // 안내
          message: '수급업체를 지정하세요.', // 사용자를 먼저 지정하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.$emit('closePopup', selectData);
      }
    },
    rowDblclick(row) {
      if (this.popupParam.type === 'single') {
        this.$emit('closePopup', [row]);
      }
    },
  }
};
</script>
